
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2uWC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $215f316971d62193$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bHDKL = parcelRequire("bHDKL");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $koVbs = parcelRequire("koVbs");

var $hsmeR = parcelRequire("hsmeR");

var $lmyls = parcelRequire("lmyls");

var $2Ui4E = parcelRequire("2Ui4E");

var $6cNb0 = parcelRequire("6cNb0");

var $1XJ20 = parcelRequire("1XJ20");

var $cZpsT = parcelRequire("cZpsT");

var $dAfqg = parcelRequire("dAfqg");

var $Mp6qH = parcelRequire("Mp6qH");

var $1bshq = parcelRequire("1bshq");

var $8dSZI = parcelRequire("8dSZI");

var $iPj86 = parcelRequire("iPj86");

var $5ofLo = parcelRequire("5ofLo");

var $kPpft = parcelRequire("kPpft");

var $7QfjC = parcelRequire("7QfjC");
function $215f316971d62193$var$HelpNew() {
    const isProjectSimplified = (0, $dAfqg.useIsSimplifiedProject)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $2Ui4E.useTopMenus)((0, $lmyls.MENU_ID).HELP);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [topMenusValue, { off: closeAllMenus }] = (0, $2Ui4E.useTopMenus)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const { releaseNotesNotifications: releaseNotesNotifications, setReleaseNotesNotifications: setReleaseNotesNotifications } = (0, $8dSZI.useHelpButtonState)();
    const helpButtonRef = (0, $5uXOq.useRef)(null);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attributes = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-2') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useMemo)(()=>({
            helpPanelVersion: (0, $6BNJk.HELP_PANEL_VERSION),
            helpPanelType: 'inProductHelp',
            nextGenProject: isProjectSimplified
        }), [
        isProjectSimplified
    ]) : {
        helpPanelVersion: (0, $6BNJk.HELP_PANEL_VERSION),
        helpPanelType: 'inProductHelp',
        nextGenProject: isProjectSimplified
    };
    const triggerAnalytics = (0, $iPj86.useNavigationItemAnalytics)({
        navigationItemId: (0, $Mp6qH.NAVIGATION_ITEM_ID).HELP
    });
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const currentRightSidebarState = (0, $hsmeR.useActiveRightSidebarState)();
    const isHelpPanelOpenedPreviously = (0, $1XJ20.usePrevious)(currentRightSidebarState);
    const testIdPrefix = (0, $6cNb0.testIdGenerate)('secondary-actions', 'help');
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (currentRightSidebarState && currentRightSidebarState.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState.isCollapsed) closeCurrentRightSidebar();
        else openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        closeAllMenus();
        setNavigationData({
            articleId: {
                id: '',
                type: (0, $bHDKL.ARTICLE_TYPE).HELP_ARTICLE
            },
            history: []
        });
        // Shows if the help panel is currently open or closed
        const isPanelOpen = currentRightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed;
        triggerAnalytics({
            ...attributes,
            isOpened: !isPanelOpen
        });
    }, [
        triggerAnalytics,
        attributes,
        currentRightSidebarState,
        closeAllMenus,
        setNavigationData,
        closeCurrentRightSidebar,
        openRightSidebar
    ]);
    const badge = (0, $5uXOq.useCallback)(()=>{
        if (isAnonymous) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ofLo.BadgeWithoutClient), {
            releaseNotesNotifications: releaseNotesNotifications ?? 0
        });
    }, [
        isAnonymous,
        releaseNotesNotifications
    ]);
    // Restore the notifications count when the help panel is opened and the notifications count is not 0
    // We explicitly check for the collapsed state, as currentRightSidebarState is null when the sidebar is closed
    // and we don't want to set the notifications count to 0 in that case
    const shouldRestoreNotificationsCount = currentRightSidebarState?.isCollapsed === false && releaseNotesNotifications !== 0;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRestoreNotificationsCount) setReleaseNotesNotifications(0);
    }, [
        setReleaseNotesNotifications,
        shouldRestoreNotificationsCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (currentRightSidebarState?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed) openMenu();
        else {
            closeMenu();
            if (isHelpPanelOpenedPreviously?.panelId === (0, $6BNJk.HELP_PANEL_ID) && !currentRightSidebarState) requestAnimationFrame(()=>helpButtonRef.current?.focus());
        }
    }, [
        closeMenu,
        currentRightSidebarState,
        isHelpPanelOpenedPreviously,
        openMenu,
        topMenusValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $6cNb0.testIdConcat)(testIdPrefix, 'menu-trigger'),
        "data-vc": `atlassian-navigation-help${false ? '-ssr' : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QfjC.SpotlightTargetComponent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bshq.Help), {
        "aria-expanded": false,
        "aria-haspopup": false,
        isSelected: isMenuOpen,
        badge: badge,
        onClick: onClick,
        tooltip: formatMessage((0, $kPpft.default).tooltip),
        label: formatMessage((0, $kPpft.default).label),
        ref: helpButtonRef
    })));
}
var $215f316971d62193$export$2e2bcd8739ae039 = $215f316971d62193$var$HelpNew;

});
parcelRegister("bHDKL", function(module, exports) {

$parcel$export(module.exports, "ARTICLE_TYPE", () => $d93cba26535df61b$export$a72bfd9b1e5592c8);
var $d93cba26535df61b$export$a72bfd9b1e5592c8 = /*#__PURE__*/ function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    return ARTICLE_TYPE;
}({});

});

parcelRegister("6BNJk", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $20386d7da4313ff0$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $20386d7da4313ff0$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $20386d7da4313ff0$export$23aa6670f346c214);

var $gwIPs = parcelRequire("gwIPs");
const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
const $20386d7da4313ff0$export$23aa6670f346c214 = (0, $gwIPs.gridSize) * 46;

});

parcelRegister("kspz4", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $aee6103177ce0723$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $aee6103177ce0723$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $jgGDm = parcelRequire("jgGDm");
const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $3sQ5x.createHook)((0, $jgGDm.default));
const $aee6103177ce0723$export$c61f56f4797e22db = (0, $3sQ5x.createHook)((0, $jgGDm.default), {
    selector: null
});
const $aee6103177ce0723$export$513717a84f55db1a = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelSubscriber'
});
const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("jgGDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465615692863cce9$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $iXqE5 = parcelRequire("iXqE5");

var $958ua = parcelRequire("958ua");
let $465615692863cce9$var$iphStorage;
const $465615692863cce9$var$createStorage = ()=>{
    if ($465615692863cce9$var$iphStorage) return $465615692863cce9$var$iphStorage;
    $465615692863cce9$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
    return $465615692863cce9$var$iphStorage;
};
const $465615692863cce9$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $465615692863cce9$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $465615692863cce9$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'help-panel',
    initialState: $465615692863cce9$var$initialState,
    actions: $958ua
});

});
parcelRegister("958ua", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $177ac56c5a5bf49e$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $177ac56c5a5bf49e$export$cdabe01d01a8da1e);

var $eNf8a = parcelRequire("eNf8a");
const $177ac56c5a5bf49e$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $177ac56c5a5bf49e$var$iphStorage.set('history', []);
    };
const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $011794d66b906d20$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $5uXOq.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("1bshq", function(module, exports) {

$parcel$export(module.exports, "Help", () => $a05c7042ce796542$export$1be7516c0280bee8);

var $5uXOq = parcelRequire("5uXOq");

var $4YvKq = parcelRequire("4YvKq");

var $9kXvc = parcelRequire("9kXvc");

var $dH7Ir = parcelRequire("dH7Ir");

var $3HwlS = parcelRequire("3HwlS");

var $6s1PB = parcelRequire("6s1PB");
const $a05c7042ce796542$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    if (!(0, $6s1PB.expVal)('blu-6875-nav4-perf-help-button', 'cohort', false) && false) {
        if ((0, $3HwlS.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kXvc.Nav4SkeletonHelpButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kXvc.SkeletonHelpButton), {
            label: props.tooltip
        });
    }
    if ((0, $3HwlS.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dH7Ir.Help), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            ref: ref
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YvKq.Help), buttonProps);
});

});
parcelRegister("4YvKq", function(module, exports) {

$parcel$export(module.exports, "Help", () => $8f34ba1016bafdbb$export$1be7516c0280bee8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dg0Fl = parcelRequire("dg0Fl");

var $gKAEK = parcelRequire("gKAEK");

var $2WekC = parcelRequire("2WekC");

var $7Onh2 = parcelRequire("7Onh2");
const $8f34ba1016bafdbb$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $8f34ba1016bafdbb$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    const { mode: { navigation: navigation } } = (0, $gKAEK.useTheme)();
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Onh2.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            color: "currentColor",
            spacing: "spacious",
            LEGACY_secondaryColor: navigation.backgroundColor
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    });
    return badge ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WekC.BadgeContainer), {
        id: $8f34ba1016bafdbb$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: button
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: button
    });
});

});
parcelRegister("dg0Fl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a6d49390b09b82e$var$_react = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9a6d49390b09b82e$var$_questionCircle = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("8nk07")));

var $9a6d49390b09b82e$var$_questionCircle2 = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("eJS47")));
function $9a6d49390b09b82e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a6d49390b09b82e$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $9a6d49390b09b82e$var$_react.default.createElement($9a6d49390b09b82e$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $9a6d49390b09b82e$var$_questionCircle2.default
    }, props));
$9a6d49390b09b82e$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $9a6d49390b09b82e$var$_default = module.exports.default = $9a6d49390b09b82e$var$QuestionCircleIcon;

});
parcelRegister("8nk07", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $618ffc7dfbf067c7$var$_react = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $618ffc7dfbf067c7$var$_baseNew = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $618ffc7dfbf067c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $618ffc7dfbf067c7$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $618ffc7dfbf067c7$var$_react.default.createElement($618ffc7dfbf067c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$618ffc7dfbf067c7$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $618ffc7dfbf067c7$var$_default = module.exports.default = $618ffc7dfbf067c7$var$QuestionCircleIcon;

});

parcelRegister("eJS47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abaf34f2ab9c61b9$var$_react = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $abaf34f2ab9c61b9$var$_questionCircle = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("8nk07")));
function $abaf34f2ab9c61b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abaf34f2ab9c61b9$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $abaf34f2ab9c61b9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $abaf34f2ab9c61b9$var$_questionCircle.default
    }));
$abaf34f2ab9c61b9$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $abaf34f2ab9c61b9$var$_default = module.exports.default = $abaf34f2ab9c61b9$var$QuestionCircleIcon;

});



parcelRegister("9kXvc", function(module, exports) {

$parcel$export(module.exports, "SkeletonHelpButton", () => $70aba88b02ff347a$export$9ee5d6e291d4e456);
$parcel$export(module.exports, "Nav4SkeletonHelpButton", () => $70aba88b02ff347a$export$c25bc9ca782b25f4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dg0Fl = parcelRequire("dg0Fl");

var $8nk07 = parcelRequire("8nk07");

var $3XuTW = parcelRequire("3XuTW");

var $gKAEK = parcelRequire("gKAEK");
const $70aba88b02ff347a$export$9ee5d6e291d4e456 = ({ label: label = '' })=>{
    const { mode: { navigation: navigation } } = (0, $gKAEK.useTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3XuTW.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
            label: label,
            color: "currentColor",
            LEGACY_secondaryColor: navigation.backgroundColor
        })
    });
};
const $70aba88b02ff347a$export$c25bc9ca782b25f4 = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3XuTW.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8nk07))), {
            label: label,
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("dH7Ir", function(module, exports) {

$parcel$export(module.exports, "Help", () => $98742630564c23b2$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8nk07 = parcelRequire("8nk07");

var $9MMay = parcelRequire("9MMay");

var $e9D17 = parcelRequire("e9D17");
const $98742630564c23b2$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $98742630564c23b2$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8nk07))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9D17.EndItem), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MMay.BadgeContainer), {
        id: $98742630564c23b2$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9D17.EndItem), {
        ...sharedProps,
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});

});


parcelRegister("8dSZI", function(module, exports) {

$parcel$export(module.exports, "useHelpButtonState", () => $dbb456bea3760752$export$e3d3de46b23d1ede);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $a6zkS = parcelRequire("a6zkS");
const $dbb456bea3760752$export$53f45136e435c2fd = 'help_button_ui_state';
const $dbb456bea3760752$export$e3d3de46b23d1ede = ()=>{
    const [releaseNotesNotifications, setReleaseNotesNotifications] = (0, $5uXOq.useState)(null);
    const [userReleaseNotesNotifications, setUserReleaseNotesNotifications] = (0, $5uXOq.useState)(null);
    const accountId = (0, $90yGq.useAccountId)();
    const updateData = (0, $5uXOq.useCallback)(()=>{
        if (userReleaseNotesNotifications !== null) {
            const newReleaseNotesNotificationsValue = userReleaseNotesNotifications !== undefined ? userReleaseNotesNotifications : 100;
            if (releaseNotesNotifications !== null) {
                if (userReleaseNotesNotifications !== releaseNotesNotifications) {
                    const remoteData = {
                        helpPanelMenu: {
                            releaseNotesNotifications: releaseNotesNotifications
                        }
                    };
                    (0, $a6zkS.updateHelpButtonState)(accountId, remoteData);
                }
            } else setReleaseNotesNotifications(newReleaseNotesNotificationsValue);
        }
    }, [
        accountId,
        releaseNotesNotifications,
        userReleaseNotesNotifications
    ]);
    const restoreReleaseNotesNotifications = (0, $5uXOq.useCallback)(async ()=>{
        if (accountId) {
            const userPropertiesHelpButtonValue = await (0, $a6zkS.getHelpButtonState)(accountId);
            setUserReleaseNotesNotifications(userPropertiesHelpButtonValue?.releaseNotesNotifications);
        } else setUserReleaseNotesNotifications(0);
    }, [
        accountId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userReleaseNotesNotifications === null) restoreReleaseNotesNotifications();
        else updateData();
    }, [
        userReleaseNotesNotifications,
        restoreReleaseNotesNotifications,
        updateData
    ]);
    return {
        releaseNotesNotifications: releaseNotesNotifications,
        setReleaseNotesNotifications: setReleaseNotesNotifications
    };
};

});
parcelRegister("a6zkS", function(module, exports) {

$parcel$export(module.exports, "updateHelpButtonState", () => $67d0104a4e9a215c$export$c70764abdc0ffd52);
$parcel$export(module.exports, "getHelpButtonState", () => $67d0104a4e9a215c$export$9716b2ae6c8887b0);

var $8QpSo = parcelRequire("8QpSo");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

const $67d0104a4e9a215c$export$c70764abdc0ffd52 = async (accountId, data)=>{
    if (accountId !== null) try {
        await (0, $89SaW.setUserProperties)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd), JSON.stringify(data));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'updateServerHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
};
const $67d0104a4e9a215c$var$getHelpButtonStateNew = (0, $8QpSo.default)(async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
});
const $67d0104a4e9a215c$var$getHelpButtonStateOld = async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $89SaW.getUserProperty)(accountId, (0, $2c95e3030594e0a4$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
};
const $67d0104a4e9a215c$export$9716b2ae6c8887b0 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-properties-iv-llc-unnecessary-api'), $67d0104a4e9a215c$var$getHelpButtonStateNew, $67d0104a4e9a215c$var$getHelpButtonStateOld);

});
const $2c95e3030594e0a4$export$53f45136e435c2fd = 'help_button_ui_state';



parcelRegister("5ofLo", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $04b8d99d5802ffbb$export$37acb3580601e69a);
$parcel$export(module.exports, "BadgeWithoutClient", () => $04b8d99d5802ffbb$export$56864788d737a7a1);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("1pgoX");
var $5s0dN = parcelRequire("5s0dN");

var $kspz4 = parcelRequire("kspz4");

var $admgR = parcelRequire("admgR");
class $04b8d99d5802ffbb$var$MockNotificationLogClient extends (0, $5s0dN.default) {
    constructor(countValue){
        super('', ''), this.count = 0;
        this.count = countValue;
    }
    countUnseenNotifications() {
        return Promise.resolve({
            count: this.count
        });
    }
}
const $04b8d99d5802ffbb$var$emptyClient = new $04b8d99d5802ffbb$var$MockNotificationLogClient(0);
const $04b8d99d5802ffbb$export$32bd6ac078326cec = async (isNotificationCleared)=>{
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $kspz4.useHelpPanel)();
    // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const notificationLogProvider = (0, $5uXOq.useMemo)(()=>new $04b8d99d5802ffbb$var$MockNotificationLogClient(releaseNotesNotifications), [
        releaseNotesNotifications
    ]);
    const result = await Promise.resolve(isNotificationCleared || false || releaseNotesNotifications === 0 ? $04b8d99d5802ffbb$var$emptyClient : notificationLogProvider);
    return result;
};
const $04b8d99d5802ffbb$export$37acb3580601e69a = ({ isNotificationCleared: isNotificationCleared })=>{
    const [notifications, setNotifications] = (0, $5uXOq.useState)(0);
    const notificationLogProvider = $04b8d99d5802ffbb$export$32bd6ac078326cec(isNotificationCleared);
    (0, $5uXOq.useEffect)(()=>{
        const initNotifications = async ()=>{
            const result = await notificationLogProvider;
            setNotifications(result.count);
        };
        initNotifications();
    }, [
        notificationLogProvider
    ]);
    return notifications > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $admgR.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, notifications) : null;
};
const $04b8d99d5802ffbb$export$56864788d737a7a1 = ({ releaseNotesNotifications: releaseNotesNotifications = 0 })=>{
    return releaseNotesNotifications > 0 && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $admgR.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, releaseNotesNotifications) : null;
};

});
parcelRegister("1pgoX", function(module, exports) {

$parcel$export(module.exports, "NotificationLogClient", () => (parcelRequire("5s0dN")).default);

var $5s0dN = parcelRequire("5s0dN");

});
parcelRegister("5s0dN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc40da511b16d48e$export$2e2bcd8739ae039);

var $dS9cn = parcelRequire("dS9cn");
const $bc40da511b16d48e$export$b055de0e665cb20c = 'atlaskitNotificationLogClient';
class $bc40da511b16d48e$export$2e2bcd8739ae039 {
    constructor(baseUrl, cloudId, source = $bc40da511b16d48e$export$b055de0e665cb20c){
        this.serviceConfig = {
            url: baseUrl
        };
        this.cloudId = cloudId;
        this.source = source;
    }
    async countUnseenNotifications(options = {}) {
        const mergedOptions = {
            path: '/api/3/notifications/count/unseen',
            ...options,
            queryParams: {
                ...this.cloudId && {
                    cloudId: this.cloudId
                },
                source: this.source,
                ...options.queryParams || {}
            },
            requestInit: {
                mode: 'cors',
                headers: {
                    'x-app-version': `${"0.0.0-use.local"}-${$bc40da511b16d48e$export$b055de0e665cb20c}`
                },
                ...options.requestInit || {}
            }
        };
        return (0, $dS9cn.utils).requestService(this.serviceConfig, mergedOptions);
    }
}

});
parcelRegister("dS9cn", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("99RON")).AbstractResource);

$parcel$export(module.exports, "utils", () => $6539d5230a113c0b$export$eab97d15b1788b8d);
parcelRequire("3bFmZ");
parcelRequire("99RON");

var $aF8YM = parcelRequire("aF8YM");

var $8Q0SU = parcelRequire("8Q0SU");
const $6539d5230a113c0b$export$eab97d15b1788b8d = $aF8YM;
const $6539d5230a113c0b$export$3b4c04cf7dad0e50 = $8Q0SU;

});
parcelRegister("3bFmZ", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $1dde2ae50887ec17$export$2ac26f1ab7eda637);
const $1dde2ae50887ec17$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("99RON", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $e1e58db2ea52ba80$export$4529f10aed0950d4);
class $e1e58db2ea52ba80$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("aF8YM", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $4cb3782fbf0bac5b$export$97bfde5a702aaeca);

var $tcn7E = parcelRequire("tcn7E");

var $VSDnB = parcelRequire("VSDnB");

var $gSA3s = parcelRequire("gSA3s");

var $3bFmZ = parcelRequire("3bFmZ");

var $2HFDN = parcelRequire("2HFDN");
const $4cb3782fbf0bac5b$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2HFDN.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2HFDN.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2HFDN.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $3bFmZ.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $VSDnB.fg)('platform_collab_provider_tracingheaders');
    (0, $gSA3s.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $tcn7E.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $4cb3782fbf0bac5b$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2HFDN", function(module, exports) {

$parcel$export(module.exports, "defaultRequestServiceOptions", () => $d06f18f7b97ba436$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $d06f18f7b97ba436$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $d06f18f7b97ba436$export$7d6ed858a91629c3);
const $d06f18f7b97ba436$export$160dbda113bfad3b = {};
const $d06f18f7b97ba436$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $d06f18f7b97ba436$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $d06f18f7b97ba436$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $d06f18f7b97ba436$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $d06f18f7b97ba436$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("8Q0SU", function(module, exports) {

$parcel$export(module.exports, "requestServiceMultipart", () => $6251c78b414c941c$export$8b13532c81e8ac89);

var $lGkPt = parcelRequire("lGkPt");

var $3bFmZ = parcelRequire("3bFmZ");

var $2HFDN = parcelRequire("2HFDN");

var $VSDnB = parcelRequire("VSDnB");

var $gSA3s = parcelRequire("gSA3s");

var $tcn7E = parcelRequire("tcn7E");
const $6251c78b414c941c$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2HFDN.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2HFDN.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2HFDN.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $3bFmZ.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $VSDnB.fg)('platform_collab_provider_tracingheaders');
    (0, $gSA3s.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $tcn7E.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $lGkPt.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $6251c78b414c941c$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("lGkPt", function(module, exports) {

$parcel$export(module.exports, "meros", () => $fc8dad7b24d7fa67$export$74e0a034be2368c7);
var $fc8dad7b24d7fa67$var$e = new TextDecoder;
async function $fc8dad7b24d7fa67$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $fc8dad7b24d7fa67$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});





parcelRegister("admgR", function(module, exports) {

$parcel$export(module.exports, "LazyNotifications", () => $c9ac2a12d590e98a$export$eebecbd0322becdd);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $Mp6qH = parcelRequire("Mp6qH");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c9ac2a12d590e98a$var$Notifications = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("7ciDR")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/badge/src/index.tsx"
});
const $c9ac2a12d590e98a$export$eebecbd0322becdd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "help.atlaskit-badge",
        packageName: (0, $Mp6qH.PACKAGE_NAME),
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "lazy-notification-badge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9ac2a12d590e98a$var$Notifications, props)));

});
parcelRegister("7ciDR", function(module, exports) {

let $53d81d4f7b6f5894$var$load = (parcelRequire("28QjX"))(4);
module.exports = $53d81d4f7b6f5894$var$load("1171Z").then(()=>parcelRequire('a5cvw'));

});



parcelRegister("kPpft", function(module, exports) {

$parcel$export(module.exports, "default", () => $e66fc02bdc2bad41$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e66fc02bdc2bad41$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.help.tooltip",
        "defaultMessage": "Help"
    },
    label: {
        "id": "atlassian-navigation.help.label",
        "defaultMessage": "Help"
    }
});

});

parcelRegister("7QfjC", function(module, exports) {

$parcel$export(module.exports, "SpotlightTargetComponent", () => $135ad9fdd5d698e5$export$70a45859468ee32a);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $g8I5C = parcelRequire("g8I5C");

var $3HwlS = parcelRequire("3HwlS");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $ajOhG = parcelRequire("ajOhG");

var $heI7y = parcelRequire("heI7y");

var $Mp6qH = parcelRequire("Mp6qH");
const $135ad9fdd5d698e5$export$70a45859468ee32a = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5788-spotlight-help-button'), $135ad9fdd5d698e5$var$JWMFeedbackSpotlightWrapper, $135ad9fdd5d698e5$var$SpotlightTargetComponentOriginal);
function $135ad9fdd5d698e5$var$SpotlightTargetComponentOriginal({ children: children }) {
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($135ad9fdd5d698e5$var$SpotlightTarget, {
        name: (0, $Mp6qH.HELP_SPOTLIGHT_KEY)
    }, children), (0, $4R6GH.fg)('add_engagement_spotlight_to_navbar_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        name: (0, $Mp6qH.HELP_SPOTLIGHT_KEY)
    }));
}
function $135ad9fdd5d698e5$var$SpotlightTarget({ children: children, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
}
function $135ad9fdd5d698e5$var$JWMFeedbackSpotlightWrapper({ children: children }) {
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((kids)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajOhG.FeedbackNudgeAsync), null, kids), []);
    const [{ hasOpened: shouldShowNudge }] = (0, $heI7y.useHasOpened)();
    const [isUnloaded] = (0, $cE2Qr.useIsDismissed)();
    const [openTask] = (0, $cE2Qr.useOpenTask)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isUnloaded && openTask === (0, $8Bc5A.JWM_FEEDBACK_TASK) && shouldShowNudge) setHasNudgeActive(true);
    }, [
        isUnloaded,
        openTask,
        shouldShowNudge,
        setHasNudgeActive
    ]);
    return !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($135ad9fdd5d698e5$var$SpotlightTargetComponentOriginal, null, children);
}

});
parcelRegister("g8I5C", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0174d522ba9dfb06$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, $axUP7.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4ZIaA = parcelRequire("4ZIaA");
var $c8E4X = parcelRequire("c8E4X");
var $eX4XX = parcelRequire("eX4XX");
var $aKz2G = parcelRequire("aKz2G");
var $aj7M6 = parcelRequire("aj7M6");
var $kUAkd = parcelRequire("kUAkd");
var $3WK4F = parcelRequire("3WK4F");
var $4CWca = parcelRequire("4CWca");
var $9xmqY = parcelRequire("9xmqY");
var $31ERv = parcelRequire("31ERv");
var $cIcFn = parcelRequire("cIcFn");
var $j3yGs = parcelRequire("j3yGs");

var $2MLVq = parcelRequire("2MLVq");
var $jjRN8 = parcelRequire("jjRN8");
var $hOWCC = parcelRequire("hOWCC");
var $ZlCus = parcelRequire("ZlCus");
var $1EWMr = parcelRequire("1EWMr");
var $kTus1 = parcelRequire("kTus1");
var $7g4r8 = parcelRequire("7g4r8");

var $3HwlS = parcelRequire("3HwlS");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1EWMr.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WK4F.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjRN8.Banner), {
        height: props.height,
        testId: props.testId,
        id: props.id
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ZIaA.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7g4r8.TopNav), {
        height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31ERv.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eX4XX.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj7M6.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKz2G.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOWCC.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUAkd.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8E4X.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MLVq.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9xmqY.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZlCus.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CWca.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cIcFn.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $565cb8192fc4e070$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $565cb8192fc4e070$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $565cb8192fc4e070$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $565cb8192fc4e070$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $565cb8192fc4e070$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $565cb8192fc4e070$export$aeff86a16f13529);

});
parcelRegister("4ZIaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $046aa419aa6d0212$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $046aa419aa6d0212$var$bannerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $565cb8192fc4e070$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$238d30785c4bca84)
});
const $046aa419aa6d0212$var$bannerFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $565cb8192fc4e070$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $565cb8192fc4e070$export$f963aecf2d4465bd)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $046aa419aa6d0212$var$Banner = (props)=>{
    const { children: children, height: height = (0, $565cb8192fc4e070$export$be83e7118304b28e), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$bcd94a6a792e7f96), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$bcd94a6a792e7f96)]: bannerHeight
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$bcd94a6a792e7f96)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $046aa419aa6d0212$var$bannerStyles,
                isFixed && $046aa419aa6d0212$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$bcd94a6a792e7f96),
            value: bannerHeight
        }), children));
};
var $046aa419aa6d0212$export$2e2bcd8739ae039 = $046aa419aa6d0212$var$Banner;

});
// dimension vars
const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
const $565cb8192fc4e070$export$be83e7118304b28e = 56;
const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
const $565cb8192fc4e070$export$539e68c09584883a = 240;
const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;

parcelRegister("8XpIo", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $45f0612699d6a600$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $45f0612699d6a600$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $45f0612699d6a600$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $45f0612699d6a600$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $45f0612699d6a600$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $45f0612699d6a600$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $45f0612699d6a600$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $45f0612699d6a600$export$218ece2c32b7db0e);


var $1Dapo = parcelRequire("1Dapo");
const $45f0612699d6a600$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $1Dapo.default)().setItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $45f0612699d6a600$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
const $45f0612699d6a600$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $1Dapo.default)().setItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $45f0612699d6a600$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $45f0612699d6a600$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $45f0612699d6a600$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`), 10) || 0;
};
const $45f0612699d6a600$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $565cb8192fc4e070$export$539e68c09584883a)) / (maxWidth - (0, $565cb8192fc4e070$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $45f0612699d6a600$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $565cb8192fc4e070$export$5253dd9707b8c3ba)]: slotName
    });
const $45f0612699d6a600$export$218ece2c32b7db0e = (slotName)=>`[${0, $565cb8192fc4e070$export$5253dd9707b8c3ba}='${slotName}']`;

});
parcelRegister("1Dapo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8542dfb7c79e1b98$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $8542dfb7c79e1b98$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $8542dfb7c79e1b98$var$safeLocalStorage = ()=>{
    if ($8542dfb7c79e1b98$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $8542dfb7c79e1b98$export$2e2bcd8739ae039 = $8542dfb7c79e1b98$var$safeLocalStorage;

});


parcelRegister("2Pb5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $69aa5d485af555af$export$2e2bcd8739ae039);

var $8XpIo = parcelRequire("8XpIo");
const $69aa5d485af555af$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $8XpIo.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $8XpIo.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $69aa5d485af555af$export$2e2bcd8739ae039 = $69aa5d485af555af$var$publishGridState;

});

parcelRegister("amcy7", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $9d139aaa63675775$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $9d139aaa63675775$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $9d139aaa63675775$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $9d139aaa63675775$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $eGmKJ.default),
    unregisterSkipLink: (0, $eGmKJ.default)
});
const $9d139aaa63675775$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($9d139aaa63675775$export$4c5cc3b14c7678a);
const $9d139aaa63675775$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $9d139aaa63675775$export$c9d9cb2ee9590f87();
    (0, $5uXOq.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("fZqMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $be1b215f3de827c6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $be1b215f3de827c6$var$focusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $be1b215f3de827c6$var$sidebarFocusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $be1b215f3de827c6$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($be1b215f3de827c6$var$sidebarFocusStyles) : css($be1b215f3de827c6$var$focusStyles)
        }));
};
var $be1b215f3de827c6$export$2e2bcd8739ae039 = $be1b215f3de827c6$var$SlotFocusRing;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("jUxG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bb67776ddc8896$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $h9kUS = parcelRequire("h9kUS");
/**
 * Hoists slot dimension styles to the root element.
 */ const $16bb67776ddc8896$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $h9kUS.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};
var $16bb67776ddc8896$export$2e2bcd8739ae039 = $16bb67776ddc8896$var$SlotDimensions;

});


parcelRegister("c8E4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a355cc90b3ba1759$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $a355cc90b3ba1759$var$contentStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $a355cc90b3ba1759$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: $a355cc90b3ba1759$var$contentStyles
    }, children);
};
var $a355cc90b3ba1759$export$2e2bcd8739ae039 = $a355cc90b3ba1759$var$Content;

});

parcelRegister("eX4XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0feeff252d3697c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $0feeff252d3697c9$var$leftPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$344062f7cfc9528e)
});
const $0feeff252d3697c9$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$f963aecf2d4465bd),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0feeff252d3697c9$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $565cb8192fc4e070$export$c4d6152f86ea28f6), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$cbfb0f5b2869b17b), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$cbfb0f5b2869b17b)]: leftPanelWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$cbfb0f5b2869b17b)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $0feeff252d3697c9$var$leftPanelStyles,
                isFixed && $0feeff252d3697c9$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$cbfb0f5b2869b17b),
            value: leftPanelWidth
        }), children));
};
var $0feeff252d3697c9$export$2e2bcd8739ae039 = $0feeff252d3697c9$var$LeftPanel;

});

parcelRegister("aKz2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d471261e665f40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $71YXv = parcelRequire("71YXv");


var $oGXFy = parcelRequire("oGXFy");



var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $j3yGs = parcelRequire("j3yGs");
var $amcy7 = parcelRequire("amcy7");

var $b8DIB = parcelRequire("b8DIB");

var $2QObc = parcelRequire("2QObc");

var $aY3ai = parcelRequire("aY3ai");

var $1hxaZ = parcelRequire("1hxaZ");

var $jUxG6 = parcelRequire("jUxG6");
const $24d471261e665f40$var$openBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $24d471261e665f40$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $24d471261e665f40$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $5uXOq.useRef)();
    const mouseOverEventRef = (0, $5uXOq.useRef)();
    const leftSideBarRef = (0, $5uXOq.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $5uXOq.useRef)(isLocked);
    const mouseXRef = (0, $5uXOq.useRef)(0);
    const handlerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $565cb8192fc4e070$export$539e68c09584883a));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$b6744d31294864fd), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $565cb8192fc4e070$export$46acf8758e9e2636);
    else leftSidebarWidthOnMount = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$a30f2e00489a8957), _width, !width || !collapsedStateOverrideOpen && (0, $8XpIo.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $5uXOq.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $8XpIo.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $8XpIo.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd], (0, $565cb8192fc4e070$export$539e68c09584883a)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd], (0, $565cb8192fc4e070$export$539e68c09584883a)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $565cb8192fc4e070$export$46acf8758e9e2636);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $565cb8192fc4e070$export$b6744d31294864fd)]: lastLeftSidebarWidth
            });
            (0, $8XpIo.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $565cb8192fc4e070$export$1074d925b0b82be5));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $565cb8192fc4e070$export$1074d925b0b82be5));
    };
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$539e68c09584883a)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $71YXv.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    /**
   * We use both the state and our effect-based ref to protect animation until initialized fully
   */ const isReady = hasInit && notFirstRun.current;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $24d471261e665f40$var$hiddenBackdropStyles,
            isFlyoutOpen && $24d471261e665f40$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aY3ai.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
        variableName: (0, $565cb8192fc4e070$export$a30f2e00489a8957),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $565cb8192fc4e070$export$70740f5ad8360a78)
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2QObc.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1hxaZ.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b8DIB.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $24d471261e665f40$export$2e2bcd8739ae039 = $24d471261e665f40$var$LeftSidebar;

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("oGXFy", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $76ca3f4294719aa5$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7yA6J = parcelRequire("7yA6J");

var $h9kUS = parcelRequire("h9kUS");
const $76ca3f4294719aa5$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $76ca3f4294719aa5$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $76ca3f4294719aa5$var$queries[queryString];
    (0, $7yA6J.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("j3yGs", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $423fcd7a7dc715d5$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $423fcd7a7dc715d5$export$94561f6055639ef7);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $423fcd7a7dc715d5$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $423fcd7a7dc715d5$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $eGmKJ.default),
    collapseLeftSidebar: (0, $eGmKJ.default),
    leftSidebarState: $423fcd7a7dc715d5$var$leftSidebarState,
    setLeftSidebarState: (0, $eGmKJ.default),
    toggleLeftSidebar: (0, $eGmKJ.default)
});
const $423fcd7a7dc715d5$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    return context;
};
const $423fcd7a7dc715d5$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    (0, $5uXOq.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("b8DIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $035100f87b948476$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $oGXFy = parcelRequire("oGXFy");


var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");

var $gYx5U = parcelRequire("gYx5U");

var $7nOWs = parcelRequire("7nOWs");

var $3bMab = parcelRequire("3bMab");
function $035100f87b948476$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $035100f87b948476$var$cssSelector = {
    [(0, $565cb8192fc4e070$export$9ecd22db14e6c70e)]: true
};
const $035100f87b948476$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $035100f87b948476$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $035100f87b948476$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $035100f87b948476$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, $565cb8192fc4e070$export$a30f2e00489a8957]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $5uXOq.useRef)(0);
    const keyboardEventTimeout = (0, $5uXOq.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
    const unbindEvents = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
    (0, $5uXOq.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $565cb8192fc4e070$export$a30f2e00489a8957] - (0, $8XpIo.getLeftPanelWidth)();
        unbindEvents.current = (0, $cBeZP.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$46acf8758e9e2636));
                        document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, $7nRxN.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $8XpIo.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $565cb8192fc4e070$export$46acf8758e9e2636) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $565cb8192fc4e070$export$46acf8758e9e2636));
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $565cb8192fc4e070$export$6949d4f32b161684)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$46acf8758e9e2636)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $565cb8192fc4e070$export$6949d4f32b161684) && sidebarWidth.current < (0, $565cb8192fc4e070$export$539e68c09584883a)) {
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$539e68c09584883a)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: (0, $565cb8192fc4e070$export$539e68c09584883a),
                lastLeftSidebarWidth: (0, $565cb8192fc4e070$export$539e68c09584883a)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $8XpIo.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $565cb8192fc4e070$export$539e68c09584883a)) {
                width = (0, $565cb8192fc4e070$export$539e68c09584883a);
                document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$539e68c09584883a) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $565cb8192fc4e070$export$539e68c09584883a);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $8XpIo.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $8XpIo.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$035100f87b948476$var$cssSelector,
        css: [
            $035100f87b948476$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $035100f87b948476$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bMab.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gYx5U.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $7nOWs.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.Global), {
        styles: $035100f87b948476$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$035100f87b948476$export$2e2bcd8739ae039 = $035100f87b948476$var$ResizeControl;

});
parcelRegister("gYx5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $859a4bb5bdb6af39$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");


function $859a4bb5bdb6af39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $859a4bb5bdb6af39$var$varLineColor = '--ds-line';
const $859a4bb5bdb6af39$var$grabAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$859a4bb5bdb6af39$var$varLineColor]: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
    }
});
const $859a4bb5bdb6af39$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $859a4bb5bdb6af39$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $859a4bb5bdb6af39$var$grabAreaLineSelector = {
    [(0, $565cb8192fc4e070$export$70c702a8c5895f03)]: true
};
const $859a4bb5bdb6af39$var$grabAreaSelector = {
    [(0, $565cb8192fc4e070$export$48a43f91e4becf4e)]: true
};
const $859a4bb5bdb6af39$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$859a4bb5bdb6af39$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $859a4bb5bdb6af39$var$grabAreaStyles,
            isLeftSidebarCollapsed && $859a4bb5bdb6af39$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $859a4bb5bdb6af39$var$lineStyles,
        ...$859a4bb5bdb6af39$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$859a4bb5bdb6af39$export$2e2bcd8739ae039 = $859a4bb5bdb6af39$var$GrabArea;

});

parcelRegister("7nOWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee2fadf0239ec76$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
                                                                                                                                                 * @jsxRuntime classic
                                                                                                                                                 * @jsx jsx
                                                                                                                                                 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $3uzfU = parcelRequire("3uzfU");


var $lObw7 = parcelRequire("lObw7");

var $h9kUS = parcelRequire("h9kUS");


function $8ee2fadf0239ec76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ee2fadf0239ec76$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $8ee2fadf0239ec76$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $8ee2fadf0239ec76$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $lObw7.durations).small}ms linear,
    color ${(0, $lObw7.durations).small}ms linear,
    opacity ${(0, $lObw7.durations).medium}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $8ee2fadf0239ec76$var$preventDefault = (event)=>event.preventDefault();
const $8ee2fadf0239ec76$var$cssSelector = {
    [(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)]: true
};
const $8ee2fadf0239ec76$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$8ee2fadf0239ec76$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $8ee2fadf0239ec76$var$resizeIconButtonStyles,
            $8ee2fadf0239ec76$var$mobileStyles,
            !isLeftSidebarCollapsed && $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $8ee2fadf0239ec76$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $8ee2fadf0239ec76$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8ee2fadf0239ec76$export$2e2bcd8739ae039 = $8ee2fadf0239ec76$var$ResizeButton;

});

parcelRegister("3bMab", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b1337ced2d81f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $dwLzP = parcelRequire("dwLzP");
const $31b1337ced2d81f3$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $31b1337ced2d81f3$var$direction = 'to left';
const $31b1337ced2d81f3$var$transitionDuration = '0.22s';
const $31b1337ced2d81f3$var$shadowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $31b1337ced2d81f3$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $eba99f58997c09b3$export$57636bb43b1ccbb0)
});
const $31b1337ced2d81f3$var$draggingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $31b1337ced2d81f3$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $dwLzP.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: [
            $31b1337ced2d81f3$var$shadowStyles,
            isDragging && $31b1337ced2d81f3$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$31b1337ced2d81f3$export$2e2bcd8739ae039 = $31b1337ced2d81f3$var$Shadow;

});
parcelRegister("dwLzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6bed85a32a6108$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $fe6bed85a32a6108$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $fe6bed85a32a6108$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)($fe6bed85a32a6108$var$getIsDragging);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($fe6bed85a32a6108$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $565cb8192fc4e070$export$802bb2c050f3db5c)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $fe6bed85a32a6108$export$2e2bcd8739ae039 = $fe6bed85a32a6108$var$useIsSidebarDragging;

});



parcelRegister("2QObc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd36b127ab52f290$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");

var $h9kUS = parcelRequire("h9kUS");


var $dwLzP = parcelRequire("dwLzP");
function $fd36b127ab52f290$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $fd36b127ab52f290$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $fd36b127ab52f290$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $565cb8192fc4e070$export$70740f5ad8360a78)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    }
});
const $fd36b127ab52f290$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $565cb8192fc4e070$export$d6e7e8af042815bb)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $565cb8192fc4e070$export$d6e7e8af042815bb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $fd36b127ab52f290$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
const $fd36b127ab52f290$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$d2fa14f05b61e66)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $fd36b127ab52f290$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $fd36b127ab52f290$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $fd36b127ab52f290$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $dwLzP.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // mobile viewport styles
            $fd36b127ab52f290$var$mobileStyles,
            isFlyoutOpen && $fd36b127ab52f290$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $fd36b127ab52f290$var$staticInnerStyles,
            isFixed && $fd36b127ab52f290$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $fd36b127ab52f290$var$fixedInnerFlyoutStyles,
            isDragging && $fd36b127ab52f290$var$draggingStyles,
            $fd36b127ab52f290$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd36b127ab52f290$export$2e2bcd8739ae039 = $fd36b127ab52f290$var$LeftSidebarInner;

});

parcelRegister("aY3ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $579ca93715ca9047$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");

var $h9kUS = parcelRequire("h9kUS");


var $dwLzP = parcelRequire("dwLzP");

var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");

var $fZqMW = parcelRequire("fZqMW");
function $579ca93715ca9047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $579ca93715ca9047$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $579ca93715ca9047$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $565cb8192fc4e070$export$70740f5ad8360a78),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $565cb8192fc4e070$export$d6e7e8af042815bb),
            content: "''"
        }
    }
});
const $579ca93715ca9047$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $579ca93715ca9047$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$f897e1ed9f8ed251),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $579ca93715ca9047$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $579ca93715ca9047$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)}`,
        content: "''"
    }
});
const $579ca93715ca9047$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$d2fa14f05b61e66)
});
const $579ca93715ca9047$var$flyoutFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$46acf8758e9e2636)
});
const $579ca93715ca9047$var$selector = (0, $8XpIo.getPageLayoutSlotSelector)('left-sidebar');
const $579ca93715ca9047$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $dwLzP.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                // mobile viewport styles
                $579ca93715ca9047$var$mobileStyles,
                isFlyoutOpen && $579ca93715ca9047$var$mobileFlyoutStyles,
                // generic styles
                $579ca93715ca9047$var$outerStyles,
                isFixed && $579ca93715ca9047$var$fixedStyles,
                isFlyoutOpen && $579ca93715ca9047$var$flyoutStyles,
                isFlyoutOpen && isFixed && $579ca93715ca9047$var$flyoutFixedStyles,
                isDragging && $579ca93715ca9047$var$draggingStyles,
                $579ca93715ca9047$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$579ca93715ca9047$var$selector
        }, children));
};
const $579ca93715ca9047$var$LeftSidebarOuter = /*#__PURE__*/ (0, $5uXOq.forwardRef)($579ca93715ca9047$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$579ca93715ca9047$export$2e2bcd8739ae039 = $579ca93715ca9047$var$LeftSidebarOuter;

});

parcelRegister("1hxaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2beb7a521c0e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");


var $2qAWW = parcelRequire("2qAWW");
function $b2beb7a521c0e059$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b2beb7a521c0e059$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $565cb8192fc4e070$export$3749e1104328fde4) - 100}ms`,
    visibility: 'hidden'
});
const $b2beb7a521c0e059$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $b2beb7a521c0e059$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $b2beb7a521c0e059$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $2qAWW.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $b2beb7a521c0e059$var$resizableChildrenWrapperStyles,
            isHidden && $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles,
            $b2beb7a521c0e059$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b2beb7a521c0e059$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b2beb7a521c0e059$export$2e2bcd8739ae039 = $b2beb7a521c0e059$var$ResizableChildrenWrapper;

});
parcelRegister("2qAWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $ed1c7c9bc9db6ce1$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f)) === 'true';
};
const $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($ed1c7c9bc9db6ce1$var$getIsCollapsing);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($ed1c7c9bc9db6ce1$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039 = $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing;

});



parcelRegister("aj7M6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26851ff0e51eadd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $2QObc = parcelRequire("2QObc");

var $aY3ai = parcelRequire("aY3ai");

var $jUxG6 = parcelRequire("jUxG6");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $c26851ff0e51eadd$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$a30f2e00489a8957), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: leftSidebarWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aY3ai.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
        variableName: (0, $565cb8192fc4e070$export$a30f2e00489a8957),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2QObc.default), {
        isFixed: isFixed
    }, children));
};
var $c26851ff0e51eadd$export$2e2bcd8739ae039 = $c26851ff0e51eadd$var$LeftSidebarWithoutResize;

});

parcelRegister("kUAkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8aae2c1ff30f289$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");



var $dwLzP = parcelRequire("dwLzP");

var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");
function $e8aae2c1ff30f289$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e8aae2c1ff30f289$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $e8aae2c1ff30f289$var$mainStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
const $e8aae2c1ff30f289$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $e8aae2c1ff30f289$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $565cb8192fc4e070$export$b6744d31294864fd)}, ${(0, $565cb8192fc4e070$export$991d5285ad765a3d)}px) + ${(0, $565cb8192fc4e070$export$46acf8758e9e2636)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $e8aae2c1ff30f289$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $dwLzP.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("main", {
            "data-testid": testId,
            css: [
                $e8aae2c1ff30f289$var$mainStyles,
                isDragging && $e8aae2c1ff30f289$var$draggingStyles,
                isFlyoutOpen && !isFixed && $e8aae2c1ff30f289$var$flyoutStyles,
                $e8aae2c1ff30f289$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('main')
        }, children));
};
var $e8aae2c1ff30f289$export$2e2bcd8739ae039 = $e8aae2c1ff30f289$var$Main;

});

parcelRegister("3WK4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a3c4908a9e1b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $h9kUS = parcelRequire("h9kUS");


var $hhjNo = parcelRequire("hhjNo");
var $ln2Pp = parcelRequire("ln2Pp");

var $crY4K = parcelRequire("crY4K");
const $864a3c4908a9e1b7$var$pageLayoutSelector = {
    [(0, $565cb8192fc4e070$export$659ee746b31b360d)]: true
};
const $864a3c4908a9e1b7$var$gridTemplateAreasMobile = `
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$238d30785c4bca84)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$bec6dca2e63de4ae)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$d1213e82613ff4df)}"
 `;
const $864a3c4908a9e1b7$var$gridTemplateAreas = `
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$238d30785c4bca84)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$bec6dca2e63de4ae)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$d1213e82613ff4df)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
 `;
const $864a3c4908a9e1b7$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} minmax(0, 1fr) ${(0, $565cb8192fc4e070$export$750459958906793)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} ${(0, $565cb8192fc4e070$export$aeff86a16f13529)} auto`,
    outline: 'none'
});
const $864a3c4908a9e1b7$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $864a3c4908a9e1b7$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $565cb8192fc4e070$export$206a08f7f8beb554), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ln2Pp.SkipLinksController), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $crY4K.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$864a3c4908a9e1b7$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $864a3c4908a9e1b7$var$gridStyles,
            $864a3c4908a9e1b7$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hhjNo.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $864a3c4908a9e1b7$export$2e2bcd8739ae039 = $864a3c4908a9e1b7$var$PageLayout;

});
parcelRegister("hhjNo", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $592e749dad0a6cf7$export$850bd1bba41f1448);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eGmKJ = parcelRequire("eGmKJ");

var $dWt6p = parcelRequire("dWt6p");

var $oGXFy = parcelRequire("oGXFy");


var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");
const $592e749dad0a6cf7$var$handleDataAttributesAndCb = (callback = (0, $eGmKJ.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
const $592e749dad0a6cf7$var$leftSidebarSelector = (0, $8XpIo.getPageLayoutSlotCSSSelector)('left-sidebar');
const $592e749dad0a6cf7$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $5uXOq.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $5uXOq.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$539e68c09584883a));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $dWt6p.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $dWt6p.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3yGs.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("ln2Pp", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $66b4ac88f2caca0d$export$da7be99d6a868f3d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $amcy7 = parcelRequire("amcy7");
const $66b4ac88f2caca0d$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $565cb8192fc4e070$export$5253dd9707b8c3ba)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $66b4ac88f2caca0d$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($66b4ac88f2caca0d$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $amcy7.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("crY4K", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $c39a22bbdce5fcea$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $e4yMr = parcelRequire("e4yMr");

var $dWt6p = parcelRequire("dWt6p");



var $amcy7 = parcelRequire("amcy7");
function $c39a22bbdce5fcea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c39a22bbdce5fcea$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $c39a22bbdce5fcea$var$skipLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 10px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $c39a22bbdce5fcea$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $c39a22bbdce5fcea$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $c39a22bbdce5fcea$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $c39a22bbdce5fcea$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $c39a22bbdce5fcea$var$assignIndex(num + 1, arr);
};
const $c39a22bbdce5fcea$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $amcy7.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $c39a22bbdce5fcea$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $565cb8192fc4e070$export$659ee746b31b360d)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $565cb8192fc4e070$export$206a08f7f8beb554);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $c39a22bbdce5fcea$var$skipLinkStyles,
            $c39a22bbdce5fcea$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)("p", {
        css: $c39a22bbdce5fcea$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("ol", {
        css: $c39a22bbdce5fcea$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($c39a22bbdce5fcea$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $c39a22bbdce5fcea$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
};
const $c39a22bbdce5fcea$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $c39a22bbdce5fcea$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $c39a22bbdce5fcea$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e4yMr.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $c39a22bbdce5fcea$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("4CWca", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9295d31affd013c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $d9295d31affd013c$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$c7139cc2d6110b5f)
});
const $d9295d31affd013c$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$750459958906793),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $d9295d31affd013c$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $565cb8192fc4e070$export$c3e41153b9288bcf), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$fa34f417972d6341), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$fa34f417972d6341)]: rightPanelWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$fa34f417972d6341)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $d9295d31affd013c$var$baseStyles,
                isFixed && $d9295d31affd013c$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$fa34f417972d6341),
            value: rightPanelWidth
        }), children));
};
var $d9295d31affd013c$export$2e2bcd8739ae039 = $d9295d31affd013c$var$RightPanel;

});

parcelRegister("9xmqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07a1808f1030823$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
function $a07a1808f1030823$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $a07a1808f1030823$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$b44ab66843c05a69),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $565cb8192fc4e070$export$750459958906793)})`
});
const $a07a1808f1030823$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a07a1808f1030823$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: (0, $565cb8192fc4e070$export$b44ab66843c05a69)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $a07a1808f1030823$var$fixedOuterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $565cb8192fc4e070$export$b44ab66843c05a69),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $a07a1808f1030823$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $565cb8192fc4e070$export$b92df8810d2fcd01), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$c103b605cd368aed), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$c103b605cd368aed)]: rightSidebarWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$c103b605cd368aed)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": testId,
            css: [
                $a07a1808f1030823$var$outerStyles,
                isFixed && $a07a1808f1030823$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$c103b605cd368aed),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                isFixed && $a07a1808f1030823$var$fixedInnerStyles,
                !isFixed && $a07a1808f1030823$var$staticInnerStyles
            ]
        }, children)));
};
var $a07a1808f1030823$export$2e2bcd8739ae039 = $a07a1808f1030823$var$RightSidebar;

});

parcelRegister("31ERv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf5fc6d75e2417f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $7bf5fc6d75e2417f$var$topNavigationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $565cb8192fc4e070$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$bec6dca2e63de4ae)
});
const $7bf5fc6d75e2417f$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $565cb8192fc4e070$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $565cb8192fc4e070$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $565cb8192fc4e070$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7bf5fc6d75e2417f$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $565cb8192fc4e070$export$4a98ee0bd1ae362), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$3a6a779d9181047c)]: topNavigationHeight
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$3a6a779d9181047c)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $7bf5fc6d75e2417f$var$topNavigationStyles,
                isFixed && $7bf5fc6d75e2417f$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children));
};
var $7bf5fc6d75e2417f$export$2e2bcd8739ae039 = $7bf5fc6d75e2417f$var$TopNavigation;

});

parcelRegister("cIcFn", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $a8132564ed4ca271$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $amcy7 = parcelRequire("amcy7");
const $a8132564ed4ca271$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $amcy7.useSkipLinks)();
    (0, $5uXOq.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("2MLVq", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $77d6f7adcd563578$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lp9re = parcelRequire("lp9re");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $2HiMp = parcelRequire("2HiMp");
const $77d6f7adcd563578$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $77d6f7adcd563578$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $77d6f7adcd563578$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $77d6f7adcd563578$var$getResizeBounds() {
    return $77d6f7adcd563578$var$asideWidthResizeBounds;
}
const $77d6f7adcd563578$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8",
    fullHeight: "_4t3i1osq"
};
function $77d6f7adcd563578$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixedProp, defaultWidth: defaultWidth = 330, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const isFixed = (0, $VSDnB.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $lp9re.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $5uXOq.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$77d6f7adcd563578$var$asideWidthSlotBounds.min}, ${width}px, ${$77d6f7adcd563578$var$asideWidthSlotBounds.max})`;
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        panelId: (0, $ilnvx.asidePanelSplitterId),
        cssVar: $77d6f7adcd563578$var$panelSplitterResizingVar
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $77d6f7adcd563578$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $ilnvx.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$77d6f7adcd563578$var$panelSplitterResizingVar}, ${asideVariableWidth})` : asideVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.asidePanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $77d6f7adcd563578$var$getResizeBounds,
                resizingCssVar: $77d6f7adcd563578$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-testid": testId ? `${testId}--inner` : undefined,
                    className: (0, $bwpsq.default)([
                        $77d6f7adcd563578$var$styles.fullHeight,
                        isFixed && $77d6f7adcd563578$var$styles.fixedContentArea
                    ]),
                    children: children
                })
            })
        ]
    });
}

});
parcelRegister("585q9", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $ac664e290f9d7ee4$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $ac664e290f9d7ee4$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $ac664e290f9d7ee4$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $ac664e290f9d7ee4$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerSkipLink: (0, $eGmKJ.default),
    unregisterSkipLink: (0, $eGmKJ.default)
});
const $ac664e290f9d7ee4$var$useSkipLinks = ()=>(0, $5uXOq.useContext)($ac664e290f9d7ee4$export$4c5cc3b14c7678a);
const $ac664e290f9d7ee4$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $ac664e290f9d7ee4$var$useSkipLinks();
    (0, $5uXOq.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $ac664e290f9d7ee4$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    $ac664e290f9d7ee4$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("ilnvx", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $7e0cfbaebce245b0$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $7e0cfbaebce245b0$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $7e0cfbaebce245b0$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $7e0cfbaebce245b0$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $7e0cfbaebce245b0$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $7e0cfbaebce245b0$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $7e0cfbaebce245b0$export$5db28b16b6e686bc);
$parcel$export(module.exports, "asidePanelSplitterId", () => $7e0cfbaebce245b0$export$de580d653bac8ad9);
$parcel$export(module.exports, "panelPanelSplitterId", () => $7e0cfbaebce245b0$export$3452dcb65711af44);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $7e0cfbaebce245b0$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $7e0cfbaebce245b0$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $7e0cfbaebce245b0$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $7e0cfbaebce245b0$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $7e0cfbaebce245b0$export$951bf5156e86d974 = '--n_sNvw';
const $7e0cfbaebce245b0$export$594e6a30db7c057e = '--n_asDw';
const $7e0cfbaebce245b0$export$db0c2e1d744fb281 = '--n_pnlW';
const $7e0cfbaebce245b0$export$515a0b1baafe906c = '--n_bnrM';
const $7e0cfbaebce245b0$export$60ef3a7b1ed42328 = '--n_tNvM';
const $7e0cfbaebce245b0$export$1216dacffd1e9e65 = '--n_sNvlw';
const $7e0cfbaebce245b0$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $7e0cfbaebce245b0$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $7e0cfbaebce245b0$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $7e0cfbaebce245b0$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $7e0cfbaebce245b0$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $7e0cfbaebce245b0$export$855f5a09f5c99ac = '--topNavigationHeight';
const $7e0cfbaebce245b0$export$26354f9814213292 = '--bannerHeight';
const $7e0cfbaebce245b0$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $7e0cfbaebce245b0$export$753bf7651b25db91 = '--rightPanelWidth';
const $7e0cfbaebce245b0$export$6460bd6a2446260 = `calc(var(${$7e0cfbaebce245b0$export$26354f9814213292}, 0px) + var(${$7e0cfbaebce245b0$export$855f5a09f5c99ac}, 0px))`;
const $7e0cfbaebce245b0$export$3055529fab2b4edf = `var(${$7e0cfbaebce245b0$export$6bfc931a04ec5741}, 0px)`;
const $7e0cfbaebce245b0$export$166d8fd766c3eb92 = `calc(var(${$7e0cfbaebce245b0$export$bbbace2ff0c7ae1b}, 0px) + var(${$7e0cfbaebce245b0$export$753bf7651b25db91}, 0px))`;
const $7e0cfbaebce245b0$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("8oF23", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $1ee0f763875d3fec$export$66e2c1a0115af861);

var $5uXOq = parcelRequire("5uXOq");
const $1ee0f763875d3fec$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});

parcelRegister("2WR37", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $cbb560d7ba4917d9$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $cbb560d7ba4917d9$export$9f45a1325e3cdfb8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1EWMr = parcelRequire("1EWMr");
const $cbb560d7ba4917d9$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: `#${(0, $1EWMr.gridRootId)} { ${variableName}: ${value}px }`
    });
const $cbb560d7ba4917d9$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $cbb560d7ba4917d9$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};

});
parcelRegister("1EWMr", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $f4db93acd3b1ab5b$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dlnxJ = parcelRequire("dlnxJ");

var $iuUiD = parcelRequire("iuUiD");

var $ivVtd = parcelRequire("ivVtd");

var $3Z6qh = parcelRequire("3Z6qh");

var $8oF23 = parcelRequire("8oF23");

var $5rLY7 = parcelRequire("5rLY7");

var $jDR0c = parcelRequire("jDR0c");

var $UTmRP = parcelRequire("UTmRP");
const $f4db93acd3b1ab5b$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $f4db93acd3b1ab5b$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $UTmRP.SideNavVisibilityProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDR0c.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rLY7.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z6qh.TopNavStartProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dlnxJ.OpenLayerObserver), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oF23.DangerouslyHoistSlotSizes).Provider, {
                            value: UNSAFE_dangerouslyHoistSlotSizes,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ivVtd.SkipLinksProvider), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iuUiD.SkipLinksContainer), {
                                        label: skipLinksLabel,
                                        testId: testId
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                        ref: ref,
                                        className: (0, $bwpsq.default)([
                                            $f4db93acd3b1ab5b$var$styles.root,
                                            xcss
                                        ]),
                                        id: $f4db93acd3b1ab5b$export$a6d827031bcb31d1,
                                        "data-testid": testId,
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("dlnxJ", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $db6ff2d140327fd6$export$97afddda23bcd287);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $kEhTY = parcelRequire("kEhTY");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $db6ff2d140327fd6$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $db6ff2d140327fd6$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $db6ff2d140327fd6$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $db6ff2d140327fd6$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The `onClose` listeners for each namespace.
	 * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
	 * callback is registered in this set.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerCloseListenerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($db6ff2d140327fd6$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $db6ff2d140327fd6$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * If a namespace is provided, the count for that namespace is returned.
	 * Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace } = {}) {
        if (namespace) return namespaceToLayerCloseListenerRegistry.get(namespace)?.size ?? 0;
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $db6ff2d140327fd6$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $db6ff2d140327fd6$var$noNamespaceSymbol;
        const listenersForNamespace = $db6ff2d140327fd6$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace }) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            listener();
        }
        const namespace = providedNamespace ?? $db6ff2d140327fd6$var$noNamespaceSymbol;
        const listenersForNamespace = $db6ff2d140327fd6$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach((listener)=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $db6ff2d140327fd6$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $5uXOq.useState)(()=>$db6ff2d140327fd6$var$createInternalAPI());
    const parentContext = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $3joPi.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kEhTY.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("iuUiD", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $4SKIy = parcelRequire("4SKIy");

var $hgvjm = parcelRequire("hgvjm");
const $8a6fecf6d9ada26f$var$styles = {
    root: "_zulp1b66 _2rkoglpi _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ const $8a6fecf6d9ada26f$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $8a6fecf6d9ada26f$var$isOnlyWhitespaceRegex = /^\s*$/;
const $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1 = ({ label: label, testId: testId })=>{
    const sortedSkipLinks = (0, $4SKIy.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const isEmptyLabel = $8a6fecf6d9ada26f$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        onKeyDown: $8a6fecf6d9ada26f$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $bwpsq.default)([
            $8a6fecf6d9ada26f$var$styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                weight: "bold",
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
                className: (0, $bwpsq.default)([
                    $8a6fecf6d9ada26f$var$styles.skipLinkList
                ]),
                children: sortedSkipLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hgvjm.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
};

});
parcelRegister("4SKIy", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $a6322a25f6b08ecb$export$b0b0d4fc1b356759);

var $5uXOq = parcelRequire("5uXOq");
const $a6322a25f6b08ecb$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $a6322a25f6b08ecb$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $a6322a25f6b08ecb$var$assignIndex(num + 1, arr);
};
const $a6322a25f6b08ecb$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $a6322a25f6b08ecb$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $a6322a25f6b08ecb$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $5uXOq.useContext)($a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
    return (0, $5uXOq.useMemo)(()=>{
        return $a6322a25f6b08ecb$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("hgvjm", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $ca929d4ef6b95820$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $jhmo0 = parcelRequire("jhmo0");
const $ca929d4ef6b95820$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $ca929d4ef6b95820$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $cBeZP.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $ca929d4ef6b95820$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate?.();
        $ca929d4ef6b95820$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            $ca929d4ef6b95820$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

});


parcelRegister("ivVtd", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $04aeed0b84d4da87$export$fe514f9f7b03d46f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $585q9 = parcelRequire("585q9");

var $4SKIy = parcelRequire("4SKIy");
const $04aeed0b84d4da87$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $04aeed0b84d4da87$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($04aeed0b84d4da87$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $585q9.SkipLinksContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4SKIy.SkipLinksDataContext).Provider, {
            value: links,
            children: children
        })
    });
};

});

parcelRegister("3Z6qh", function(module, exports) {

$parcel$export(module.exports, "TopNavStartProvider", () => $ac9d25344fa2e979$export$bc9d0ad0bce43e75);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7NFvZ = parcelRequire("7NFvZ");
const $ac9d25344fa2e979$export$bc9d0ad0bce43e75 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7NFvZ.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7NFvZ.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("5rLY7", function(module, exports) {

$parcel$export(module.exports, "SideNavElementProvider", () => $60c376fb0d7017f3$export$85c1ff84bbf6e6dc);
$parcel$export(module.exports, "useSideNavRef", () => $60c376fb0d7017f3$export$fa4d0cff03b1ea4f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $60c376fb0d7017f3$var$SideNavRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    current: null
});
function $60c376fb0d7017f3$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($60c376fb0d7017f3$var$SideNavRefContext.Provider, {
        value: sideNavRef,
        children: children
    });
}
function $60c376fb0d7017f3$export$fa4d0cff03b1ea4f() {
    return (0, $5uXOq.useContext)($60c376fb0d7017f3$var$SideNavRefContext);
}

});

parcelRegister("jDR0c", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $e430d141e8d30234$export$ceb8e60e9790fc0f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZOeM = parcelRequire("eZOeM");
const $e430d141e8d30234$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZOeM.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZOeM.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("UTmRP", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $2510be1036df6cd8$export$aac8e996360f6ad9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b0CFU = parcelRequire("b0CFU");
const $2510be1036df6cd8$export$aac8e996360f6ad9 = ({ children: children })=>{
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0CFU.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0CFU.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

});



parcelRegister("8mXqE", function(module, exports) {

$parcel$export(module.exports, "useSkipLinkId", () => $57190c324e1ec006$export$fa3cfac0c8e29c5c);
$parcel$export(module.exports, "useLayoutId", () => $57190c324e1ec006$export$110c3550c7c1c9aa);

var $9KnKW = parcelRequire("9KnKW");
function $57190c324e1ec006$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $9KnKW.useId)();
    return uniqueId;
}
function $57190c324e1ec006$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = $57190c324e1ec006$export$fa3cfac0c8e29c5c();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});

parcelRegister("fVO1C", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $0739b5288fba2b3a$export$f662bfb764348932);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9NI3h = parcelRequire("9NI3h");
const $0739b5288fba2b3a$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $5uXOq.useRef)(null);
    const context = (0, $5uXOq.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9NI3h.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});
parcelRegister("9NI3h", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $ec571489384d3ca6$export$7a4054f2c546f2cd);

var $5uXOq = parcelRequire("5uXOq");
const $ec571489384d3ca6$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("2HiMp", function(module, exports) {

$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $ef753172dcf77156$export$d4931ecf0fbcc8fc);

var $5uXOq = parcelRequire("5uXOq");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $3AWiS = parcelRequire("3AWiS");
function $ef753172dcf77156$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $4hDdm.combine)((0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $3AWiS.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("3AWiS", function(module, exports) {

$parcel$export(module.exports, "isPanelSplitterDragData", () => $f535d623adcb2c41$export$e239b3966b677000);
$parcel$export(module.exports, "PanelSplitter", () => $f535d623adcb2c41$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $3joPi = parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $98OXW = parcelRequire("98OXW");

var $e4cTf = parcelRequire("e4cTf");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("4dYas");
var $kLEEo = parcelRequire("kLEEo");
parcelRequire("hjhoK");
var $akFFC = parcelRequire("akFFC");
parcelRequire("fmZmH");
var $3C4FG = parcelRequire("3C4FG");

var $jldZL = parcelRequire("jldZL");

var $9NI3h = parcelRequire("9NI3h");

var $gRo7J = parcelRequire("gRo7J");

var $lVIfq = parcelRequire("lVIfq");

var $fAx1P = parcelRequire("fAx1P");

var $ay5e1 = parcelRequire("ay5e1");

var $1ICwz = parcelRequire("1ICwz");
const $f535d623adcb2c41$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $f535d623adcb2c41$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
const $f535d623adcb2c41$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $f535d623adcb2c41$var$panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');
function $f535d623adcb2c41$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [$f535d623adcb2c41$var$panelSplitterDragDataSymbol]: true
    };
}
function $f535d623adcb2c41$export$e239b3966b677000(data) {
    return data[$f535d623adcb2c41$var$panelSplitterDragDataSymbol] === true;
}
const $f535d623adcb2c41$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>{
    const splitterRef = (0, $5uXOq.useRef)(null);
    const panelSplitterContext = (0, $5uXOq.useContext)((0, $9NI3h.PanelSplitterContext));
    (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $1ICwz.useTextDirection)(portalRef.current);
    const labelId = (0, $9KnKW.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $5uXOq.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $5uXOq.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $e4cTf.useOpenLayerObserver)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $3joPi.default)(splitter, 'Splitter ref must be set');
        return (0, $4hDdm.combine)((0, $kLEEo.blockDraggingToIFrames)({
            element: splitter
        }), (0, $7gWdR.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $akFFC.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $3C4FG.preventUnhandled).start();
            },
            getInitialData () {
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                const initialWidth = (0, $fAx1P.getPixelWidth)(panelRef.current);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $f535d623adcb2c41$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds()
                });
            },
            onDragStart ({ source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds } = source.data;
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $fAx1P.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panelRef.current?.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                (0, $3C4FG.preventUnhandled).stop();
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                const finalWidth = (0, $fAx1P.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        direction,
        position,
        isEnabled,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $98OXW.default)(onResizeStart);
    const onResizeEndStableRef = (0, $98OXW.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $5uXOq.useState)(()=>(0, $ay5e1.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $5uXOq.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $5uXOq.useRef)(null);
    const handleSliderFocus = (0, $5uXOq.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $5uXOq.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $5uXOq.useMemo)(()=>`${(0, $lVIfq.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $bwpsq.default)([
            $f535d623adcb2c41$var$containerStyles.root,
            position === 'start' && $f535d623adcb2c41$var$containerStyles.positionStart,
            position === 'end' && $f535d623adcb2c41$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: splitterRef,
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                $f535d623adcb2c41$var$grabAreaStyles.root
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                            type: "range",
                            value: rangeInputValue,
                            step: 20,
                            min: rangeInputBounds.min,
                            max: rangeInputBounds.max,
                            "aria-valuetext": ariaValueText,
                            "aria-labelledby": labelId,
                            onChange: handleSliderInputChange,
                            onFocus: handleSliderFocus,
                            onBlur: handleSliderBlur
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            id: labelId,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $f535d623adcb2c41$var$lineStyles.root
                    ])
                })
            ]
        })
    }), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $f535d623adcb2c41$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: hasMounted ? children : null
    });
};
const $f535d623adcb2c41$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)($f535d623adcb2c41$var$ClientOnly, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f535d623adcb2c41$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId
        })
    });

});
parcelRegister("e4cTf", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $ea3ab92c791f0d5d$export$750f5b0d6c51617e);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $kEhTY = parcelRequire("kEhTY");
function $ea3ab92c791f0d5d$export$750f5b0d6c51617e() {
    const context = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $5uXOq.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        }), [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}

});

parcelRegister("4dYas", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("kLEEo")).blockDraggingToIFrames);

var $kLEEo = parcelRequire("kLEEo");

});
parcelRegister("kLEEo", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $85c97841a27447ca$export$6ae1d8fab001518c);

var $40DDD = parcelRequire("40DDD");

var $3zl3q = parcelRequire("3zl3q");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $85c97841a27447ca$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $85c97841a27447ca$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $85c97841a27447ca$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($85c97841a27447ca$var$isActive) return;
    $85c97841a27447ca$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$85c97841a27447ca$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $3zl3q.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $40DDD.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $85c97841a27447ca$var$isActive = false;
    });
}
function $85c97841a27447ca$export$6ae1d8fab001518c({ element: element }) {
    return (0, $40DDD.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $85c97841a27447ca$var$tryStart();
        }
    });
}

});


parcelRegister("hjhoK", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("akFFC")).disableNativeDragPreview);

var $akFFC = parcelRequire("akFFC");

});
parcelRegister("akFFC", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $1774d76ee1100c7d$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $1774d76ee1100c7d$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $1774d76ee1100c7d$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $1774d76ee1100c7d$var$tinyTransparentImage) nativeSetDragImage($1774d76ee1100c7d$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("fmZmH", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("3C4FG")).preventUnhandled);

var $3C4FG = parcelRequire("3C4FG");

});
parcelRegister("3C4FG", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $bc1937186f99453b$export$453c0582481cc59d);

var $cBeZP = parcelRequire("cBeZP");

var $h5V4I = parcelRequire("h5V4I");
function $bc1937186f99453b$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $bc1937186f99453b$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $bc1937186f99453b$var$start() {
    $bc1937186f99453b$var$cleanup();
    $bc1937186f99453b$var$unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragover',
            listener: $bc1937186f99453b$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $bc1937186f99453b$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $bc1937186f99453b$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $bc1937186f99453b$var$cleanup
        },
        ...(0, $h5V4I.getBindingsForBrokenDrags)({
            onDragEnd: $bc1937186f99453b$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $bc1937186f99453b$var$cleanup() {
    $bc1937186f99453b$var$unbindEvents?.();
    $bc1937186f99453b$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $bc1937186f99453b$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $bc1937186f99453b$var$cleanup();
}
const $bc1937186f99453b$export$453c0582481cc59d = {
    start: $bc1937186f99453b$var$start,
    stop: $bc1937186f99453b$var$stop
};

});


parcelRegister("gRo7J", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", () => $4ac469c14ce45896$export$3d412b3011b66f82);
function $4ac469c14ce45896$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("lVIfq", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $eb54cea8a4880815$export$b5423678cdf09f5);
function $eb54cea8a4880815$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("fAx1P", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $e9a4e6873a340be1$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $e9a4e6873a340be1$export$d942790ad00c41f9);
const $e9a4e6873a340be1$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $e9a4e6873a340be1$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("ay5e1", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $c3821cbf3d3af233$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $c3821cbf3d3af233$var$resizeCallbackDebounceTimeMs = 500;
function $c3821cbf3d3af233$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $c3821cbf3d3af233$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("1ICwz", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $19142174bc5bbe23$export$cf24a79f32f45545);

var $5uXOq = parcelRequire("5uXOq");
const $19142174bc5bbe23$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});




parcelRegister("jjRN8", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $365358079a8d32db$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");
const $365358079a8d32db$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $365358079a8d32db$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = (0, $VSDnB.fg)('platform_dst_nav4_banner_default_height') ? 48 : 64, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $365358079a8d32db$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.HoistCssVarToLocalGrid), {
                variableName: (0, $ilnvx.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_bannerVar),
                value: height
            }),
            children
        ]
    });
}

});

parcelRegister("hOWCC", function(module, exports) {

$parcel$export(module.exports, "Main", () => $325f1d6156df91d8$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $8mXqE = parcelRequire("8mXqE");

var $2GcIE = parcelRequire("2GcIE");
const $325f1d6156df91d8$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8"
};
function $325f1d6156df91d8$export$861edd1ccea2f746({ children: children, isFixed: isFixedProp, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const isFixed = (0, $VSDnB.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    (0, $585q9.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $325f1d6156df91d8$var$mainElementStyles.root,
                isFixed && $325f1d6156df91d8$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2GcIE.MainStickyContext).Provider, {
                value: Boolean(isFixed),
                children: children
            })
        })
    });
}

});
parcelRegister("2GcIE", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $7ccaf10616775f74$export$3b369e2c6c1ec840);

var $5uXOq = parcelRequire("5uXOq");
const $7ccaf10616775f74$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});


parcelRegister("ZlCus", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $05534568732462ab$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $5rLY7 = parcelRequire("5rLY7");

var $2HiMp = parcelRequire("2HiMp");
const $05534568732462ab$var$panelSplitterResizingVar = '--n_pnlRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $05534568732462ab$var$oldPanelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $05534568732462ab$var$oldPanelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $05534568732462ab$var$getOldResizeBounds() {
    return $05534568732462ab$var$oldPanelWidthResizeBounds;
}
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $05534568732462ab$var$fallbackResizeMinWidth = 400;
const $05534568732462ab$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs1cd0 _1w6ezgxb _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw",
    oldMobileWidth: "_1bsb1adv",
    newMobileWidth: "_1bsb1dxx"
};
function $05534568732462ab$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = (0, $VSDnB.fg)('platform_design_system_nav4_panel_default_border') }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $5rLY7.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $05534568732462ab$var$fallbackResizeMinWidth);
    const getNewResizeBounds = (0, $5uXOq.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */ const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${0, $ilnvx.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    } : $05534568732462ab$var$oldPanelWidthSlotBounds;
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        cssVar: $05534568732462ab$var$panelSplitterResizingVar,
        panelId: (0, $ilnvx.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $05534568732462ab$var$styles.root,
            defaultWidth === 0 && $05534568732462ab$var$styles.hidden,
            hasBorder && $05534568732462ab$var$styles.border,
            (0, $VSDnB.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? $05534568732462ab$var$styles.newMobileWidth : $05534568732462ab$var$styles.oldMobileWidth,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $ilnvx.panelVar)]: panelVariableWidth,
            '--minWidth': (0, $VSDnB.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? `${minWidth}px` : undefined
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.lg,
                responsiveValue: (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$05534568732462ab$var$panelSplitterResizingVar}, ${panelVariableWidth})` : panelVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? getNewResizeBounds : $05534568732462ab$var$getOldResizeBounds,
                resizingCssVar: $05534568732462ab$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $05534568732462ab$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

});

parcelRegister("kTus1", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $be4966f89908f895$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $5JjdN = parcelRequire("5JjdN");

var $lJmpK = parcelRequire("lJmpK");
var $e4cTf = parcelRequire("e4cTf");

var $VSDnB = parcelRequire("VSDnB");

var $7gWdR = parcelRequire("7gWdR");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $7NFvZ = parcelRequire("7NFvZ");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $2HiMp = parcelRequire("2HiMp");

var $5rLY7 = parcelRequire("5rLY7");


var $eZOeM = parcelRequire("eZOeM");

var $fD6iO = parcelRequire("fD6iO");

var $ecbZX = parcelRequire("ecbZX");

var $27t8Q = parcelRequire("27t8Q");

var $6qnkT = parcelRequire("6qnkT");

var $b0CFU = parcelRequire("b0CFU");
const $be4966f89908f895$var$panelSplitterResizingVar = '--n_snvRsz';
const $be4966f89908f895$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $be4966f89908f895$var$getResizeBounds() {
    return $be4966f89908f895$var$widthResizeBounds;
}
const $be4966f89908f895$var$openLayerObserverSideNavNamespace = 'side-nav';
const $be4966f89908f895$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_191wglyw _t51zglyw _p5clzgxb",
    newBorderFlyoutOpen: "_p5clglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $be4966f89908f895$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, id: providedId }) {
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $fD6iO.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ const synchronouslyExpandSideNav = (0, $5uXOq.useCallback)(()=>{
        (0, $7nsd3.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SideNavVisibilityState));
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $ecbZX.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $5uXOq.useState)(defaultCollapsed);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    const clampedWidth = `clamp(${$be4966f89908f895$var$widthResizeBounds.min}, ${width}px, ${$be4966f89908f895$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const navRef = (0, $5uXOq.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $5rLY7.useSideNavRef)();
    const mergedRef = (0, $5JjdN.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $5uXOq.useContext)((0, $eZOeM.SideNavToggleButtonElement));
    const topNavStartElement = (0, $5uXOq.useContext)((0, $7NFvZ.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $e4cTf.useOpenLayerObserver)();
    const flyoutStateRef = (0, $5uXOq.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const updateFlyoutState = (0, $5uXOq.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $94307ebc0fda0ded$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibility = (0, $6qnkT.useToggleSideNav)();
    (0, $5uXOq.useEffect)(()=>{
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onExpand?.({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onCollapse?.({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $27t8Q.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $5uXOq.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $5uXOq.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ const skipLinkUrlFragment = `#${id}`;
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibility();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $cBeZP.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $cBeZP.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support'),
        cssVar: $be4966f89908f895$var$panelSplitterResizingVar,
        panelId: (0, $ilnvx.sideNavPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $ilnvx.sideNavVar)]: clampedWidth
        },
        ref: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? mergedRef : navRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $be4966f89908f895$var$styles.root,
            (0, $VSDnB.fg)('platform_design_system_nav4_sidenav_border') ? $be4966f89908f895$var$styles.newBorder : $be4966f89908f895$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenMobileAndDesktop,
            sideNavState?.flyout === 'open' && $be4966f89908f895$var$styles.flyoutOpen,
            sideNavState?.flyout === 'open' && (0, $VSDnB.fg)('platform_design_system_nav4_sidenav_border') && $be4966f89908f895$var$styles.newBorderFlyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && $be4966f89908f895$var$styles.flyoutAnimateClosed
        ]),
        children: [
            (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') && // This CSS var is used by the `Panel` slot to enforce its maximum width constraint.
            // When we remove the UNSAFE legacy usage, we can change this to `HoistCssVarToLocalGrid`
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.sideNavLiveWidthVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: isExpandedOnDesktop ? `var(${$be4966f89908f895$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
            }),
            dangerouslyHoistSlotSizes && ((0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_sideNavLayoutVar),
                value: `var(${(0, $ilnvx.sideNavLiveWidthVar)})`
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_sideNavLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: isExpandedOnDesktop ? clampedWidth : 0
            })),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.sideNavPanelSplitterId),
                panelRef: navRef,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $be4966f89908f895$var$getResizeBounds,
                resizingCssVar: $be4966f89908f895$var$panelSplitterResizingVar,
                isEnabled: isExpandedOnDesktop && !isFlyoutVisible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $be4966f89908f895$var$styles.flexContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
function $be4966f89908f895$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, id: id }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJmpK.OpenLayerObserverNamespaceProvider), {
        namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($be4966f89908f895$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id,
            children: children
        })
    });
}

});
parcelRegister("lJmpK", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $68ced8fafd297685$export$327d0d2a7ae6f7cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $6uI1O = parcelRequire("6uI1O");

var $7e96v = parcelRequire("7e96v");
function $68ced8fafd297685$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $7e96v.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $3joPi.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6uI1O.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $94307ebc0fda0ded$export$a7801e29f563faad = 400;

parcelRegister("fD6iO", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", () => $d44c9e93ca4d5bd6$export$e44b4744d8ff971a);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $b0CFU = parcelRequire("b0CFU");
function $d44c9e93ca4d5bd6$export$e44b4744d8ff971a() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const expandSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("27t8Q", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $cb86acb1b056338b$export$1904b8f2577aba9a);

var $5uXOq = parcelRequire("5uXOq");

var $lp9re = parcelRequire("lp9re");
function $cb86acb1b056338b$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $5uXOq.useRef)(onExpand);
    const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
    (0, $5uXOq.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $lp9re.default)(isExpandedOnDesktop);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    const previousIsExpandedOnMobile = (0, $lp9re.default)(isExpandedOnMobile);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});


parcelRegister("7g4r8", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $c8c2cc49c7ec13a9$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $lLCVr = parcelRequire("lLCVr");

var $9SFxq = parcelRequire("9SFxq");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");
const $c8c2cc49c7ec13a9$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $c8c2cc49c7ec13a9$export$41d0d88a6b0e456f({ children: children, xcss: xcss, height: height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    (0, $585q9.useSkipLink)(id, skipLinkLabel);
    const customTheme = (0, $9SFxq.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLCVr.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $c8c2cc49c7ec13a9$var$styles.root,
                (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_columns') ? $c8c2cc49c7ec13a9$var$styles.newLayoutStyles : $c8c2cc49c7ec13a9$var$styles.oldLayoutStyles,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.HoistCssVarToLocalGrid), {
                    variableName: (0, $ilnvx.topNavMountedVar),
                    value: height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $ilnvx.UNSAFE_topNavVar),
                    value: height
                }),
                children
            ]
        })
    });
}

});
parcelRegister("9SFxq", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $a4aaf4b86ce4bd3e$export$c0c5f5b297b77726);

var $5uXOq = parcelRequire("5uXOq");

var $4ho76 = parcelRequire("4ho76");
function $a4aaf4b86ce4bd3e$export$c0c5f5b297b77726(theme) {
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $4ho76.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("4ho76", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $20b90a70389cbaea$export$3986d75fe2da3239);

var $aXYYm = parcelRequire("aXYYm");

var $8l1C4 = parcelRequire("8l1C4");

var $89F5e = parcelRequire("89F5e");

var $essik = parcelRequire("essik");

var $i38OJ = parcelRequire("i38OJ");

var $es68b = parcelRequire("es68b");
function $20b90a70389cbaea$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $20b90a70389cbaea$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $20b90a70389cbaea$var$buttonStyles = {
    light: {
        [(0, $8l1C4.themedButtonBackground)]: 'transparent',
        [(0, $8l1C4.themedButtonBackgroundHovered)]: (0, $i38OJ.palette).Neutral200A,
        [(0, $8l1C4.themedButtonBackgroundPressed)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonBorder)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonSelectedBackground)]: (0, $i38OJ.palette).Neutral300A,
        [(0, $8l1C4.themedButtonSelectedBackgroundHovered)]: (0, $i38OJ.palette).Neutral400A,
        [(0, $8l1C4.themedButtonSelectedBackgroundPressed)]: (0, $i38OJ.palette).Neutral500A,
        [(0, $8l1C4.themedButtonDisabledText)]: (0, $i38OJ.palette).Neutral400A,
        [(0, $8l1C4.themedButtonDisabledBackground)]: (0, $i38OJ.palette).Neutral100A
    },
    dark: {
        [(0, $8l1C4.themedButtonBackground)]: 'transparent',
        [(0, $8l1C4.themedButtonBackgroundHovered)]: (0, $i38OJ.palette).DarkNeutral200A,
        [(0, $8l1C4.themedButtonBackgroundPressed)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonBorder)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonSelectedBackground)]: (0, $i38OJ.palette).DarkNeutral300A,
        [(0, $8l1C4.themedButtonSelectedBackgroundHovered)]: (0, $i38OJ.palette).DarkNeutral400A,
        [(0, $8l1C4.themedButtonSelectedBackgroundPressed)]: (0, $i38OJ.palette).DarkNeutral500A,
        [(0, $8l1C4.themedButtonDisabledText)]: (0, $i38OJ.palette).DarkNeutral400A,
        [(0, $8l1C4.themedButtonDisabledBackground)]: (0, $i38OJ.palette).DarkNeutral100A
    }
};
const $20b90a70389cbaea$var$logoStyles = {
    light: {
        [(0, $aXYYm.themedLogoIcon)]: (0, $i38OJ.palette).DarkNeutral0,
        [(0, $aXYYm.themedLogoText)]: (0, $i38OJ.palette).DarkNeutral0
    },
    dark: {
        [(0, $aXYYm.themedLogoIcon)]: (0, $i38OJ.palette).Neutral0,
        [(0, $aXYYm.themedLogoText)]: (0, $i38OJ.palette).Neutral0
    }
};
function $20b90a70389cbaea$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $essik.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $essik.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $89F5e.getTextColor)(backgroundRgb);
    const colorMode = (0, $89F5e.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $89F5e.getTextColor)(highlightRgb);
    return {
        backgroundColor: $20b90a70389cbaea$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$20b90a70389cbaea$var$buttonStyles[colorMode],
        ...$20b90a70389cbaea$var$logoStyles[colorMode],
        ...$20b90a70389cbaea$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $es68b.themedSearchBorder)]: $20b90a70389cbaea$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $es68b.themedSearchBorderFocused)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $8l1C4.themedButtonPrimaryBackground)]: $20b90a70389cbaea$var$toRGBString(highlightRgb),
        [(0, $8l1C4.themedButtonPrimaryBackgroundHovered)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $8l1C4.themedButtonPrimaryBackgroundPressed)]: $20b90a70389cbaea$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $8l1C4.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $20b90a70389cbaea$var$selectedBackgroundRGBA = {
    light: (0, $i38OJ.paletteRgba).Neutral300A,
    dark: (0, $i38OJ.paletteRgba).DarkNeutral300A
};
function $20b90a70389cbaea$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $20b90a70389cbaea$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $89F5e.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $8l1C4.themedButtonSelectedText)]: (0, $89F5e.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $8l1C4.themedButtonSelectedBorder)]: (0, $89F5e.isLight)(blendedBackground) ? (0, $i38OJ.palette).Neutral1100 : (0, $i38OJ.palette).DarkNeutral1100
    };
}

});
parcelRegister("89F5e", function(module, exports) {

$parcel$export(module.exports, "isLight", () => $4fbdcc97a7190551$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $4fbdcc97a7190551$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $4fbdcc97a7190551$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $4fbdcc97a7190551$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $4fbdcc97a7190551$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $4fbdcc97a7190551$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.r),
        g: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.g),
        b: $4fbdcc97a7190551$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $4fbdcc97a7190551$var$flipLuminance = 0.179129;
function $4fbdcc97a7190551$export$44af652f4cca9039(color) {
    return $4fbdcc97a7190551$var$relativeLuminanceW3C(color) >= $4fbdcc97a7190551$var$flipLuminance;
}
function $4fbdcc97a7190551$export$5573a5bab3e074b5(backgroundColor) {
    if ($4fbdcc97a7190551$var$relativeLuminanceW3C(backgroundColor) >= $4fbdcc97a7190551$var$flipLuminance) return 'light';
    return 'dark';
}
const $4fbdcc97a7190551$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $4fbdcc97a7190551$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $4fbdcc97a7190551$export$5573a5bab3e074b5(backgroundColor);
    return $4fbdcc97a7190551$var$textColor[colorMode];
}
function $4fbdcc97a7190551$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("essik", function(module, exports) {

$parcel$export(module.exports, "parseHex", () => $352c93155f572157$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $352c93155f572157$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $352c93155f572157$export$103711ef09c6edec(color) {
    if (!$352c93155f572157$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("i38OJ", function(module, exports) {

$parcel$export(module.exports, "palette", () => $3c1e0f0bc82f150b$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $3c1e0f0bc82f150b$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $3c1e0f0bc82f150b$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $3c1e0f0bc82f150b$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});








parcelRegister("ajOhG", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudgeAsync", () => $9b3ebbbcc2dff472$export$be3f2958452e7be9);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b3ebbbcc2dff472$var$FeedbackNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5S5zV")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $9b3ebbbcc2dff472$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b3ebbbcc2dff472$var$FeedbackNudgeLazy, null, children)));
$9b3ebbbcc2dff472$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("5S5zV", function(module, exports) {

let $446652ad373994b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $446652ad373994b6$var$load("hZ95g").then(()=>parcelRequire('5YJ1A'));

});





$parcel$global.rlb("go51F")
//# sourceMappingURL=help-new.eb6fcc8b.js.map
